import styles from './invictustest.module.css'
import RightArrow from '../../assets/ArrowRight.svg'
import { getExamType } from 'utils/common'

const InvictusHowRegister = () => {
  const examType = getExamType();
  function registernow() {
    window.webengage.track(examType + '_register_now_landing', {
      // 'utm parameters': utmParams,
      // method: userMethod.isPsid ? 'psid' : 'mobile',

    })
  }

  return (
    <>
      <div id="how-it-works" className={styles.mb_reg}>
        {/* register section bottom start */}
        <div className={`${styles.icon_invictus} ${styles.d_block}`}><img src="https://dcx0p3on5z8dw.cloudfront.net/Aakash/s3fs-public/inline-images/invictus/desktop-icon-half.png" alt="" /></div>
        <div className={`${styles.model_section_reg}`}>
          <div className="container">
            <div className={`${styles.reg_wrapper_model}`}>
              <div className={`${styles.d_block}`}><img src="https://dcx0p3on5z8dw.cloudfront.net/Aakash/s3fs-public/inline-images/invictus/in-illustration-desktop.png" alt="" /></div>
              <div className={`${styles.m_block} ${styles.mweb_model}`}><img src="https://dcx0p3on5z8dw.cloudfront.net/Aakash/s3fs-public/inline-images/invictus/illustration%20.png" alt="" /></div>
              <div className={`${styles.how_register_wrapper} ${styles.d_block}`}>
                <div className={`${styles.registration_section}`}>
                  <div className={`${styles.reg_content}`}>
                    <h3>How to register?</h3>
                    <p className={`${styles.reg_subtitle}`}>In just 3-step process</p>
                    <div className={`${styles.reg_steps}`}>
                      <div className={`${styles.reg_step}`}>
                        <div className={`${styles.reg_step_number}`}>1</div>
                        <p>Verify your mobile number</p>
                      </div>
                      <div className={`${styles.reg_step}`}>
                        <div className={`${styles.reg_step_number}`}>2</div>
                        <p>Submit your details</p>
                      </div>
                      <div className={`${styles.reg_step}`}>
                        <div className={`${styles.reg_step_number}`}>3</div>
                        <p>Registration completed</p>
                      </div>
                    </div>
                    <div className={`${styles.register_success}`}><p>That’s it! You’re all set to take the next step towards success! 🚀</p></div>
                    <div className={`${styles.type_form_desktop}`}>
                      <div className={`${styles.register_btn_invictus}`}><a href="#isregister" onClick={registernow} >Register now <img src={RightArrow} alt="" /></a></div>
                      <h6>Limited seats available!</h6>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* mobile register start */}
      <div className="container">
        <div className={`${styles.how_register_wrapper} ${styles.m_block}`}>
          <div className={`${styles.registration_section}`}>
            <div className={`${styles.reg_content}`}>
              <h3>How to register?</h3>
              <p className={`${styles.reg_subtitle}`}>In just 3-step process</p>
              <div className={`${styles.reg_steps}`}>
                <div className={`${styles.reg_step}`}>
                  <div className={`${styles.reg_step_number}`}>1</div>
                  <p>Verify your mobile number</p>
                </div>
                <div className={`${styles.reg_step}`}>
                  <div className={`${styles.reg_step_number}`}>2</div>
                  <p>Submit your details</p>
                </div>
                <div className={`${styles.reg_step}`}>
                  <div className={`${styles.reg_step_number}`}>3</div>
                  <p>Registration completed</p>
                </div>
              </div>
            </div>
            <div className={`${styles.register_success}`}><p>That’s it! You’re all set to take the next step towards success! 🚀</p></div>
            <div className={`${styles.type_form_mobile}`}>
              <div className={`${styles.register_btn_invictus}`}><a href="#isregister" onClick={registernow}>Register now <img src={RightArrow} alt="" /></a></div>
              <h6>Limited seats available!</h6>
            </div>
          </div>
        </div>
      </div>
      {/* mobile register end */}
    </>
  )
}

export default InvictusHowRegister